import styled from 'styled-components';
import constants from '../../common/theme/constants';

export const InfoMessage = styled.div<{ error?: string }>`
  color: ${({ error, theme }) => (error ? theme.error : theme.label)};
  font-size: ${constants.fontSize.text_14}rem;
  margin-top: ${constants.spacing.absolute.xs}px;
`;

export const RequiredIdentifier = styled.span`
  &:after {
    content: '*';
  }
`;
